import * as yup from "yup";
import { CantidadSchema } from "./CantidadSchema";

export const AreaAcopioSolidosSchema = yup.object().shape({
  orden: yup.number().required("errors.areaAcopioSolido.orden.required"),
  solido: yup
    .object()
    .shape({
      material: yup
        .string()
        .required("errors.areaAcopioSolido.solido.material.required")
        .default(""),
      dimensionGrano: yup
        .object()
        .concat(CantidadSchema)
        .required("errors.areaAcopioSolido.solido.dimensionGrano.required")
        .test(
          "magnitud.min",
          "errors.cantidad.magnitud.min",
          (value, context) => {
            return value?.magnitud > 0;
          },
        ),
    })
    .required("errors.areaAcopioSolido.solido.required"),
  cantidad: CantidadSchema.required("errors.areaAcopioSolido.cantidad.required")
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "TNANIO" } }),
  superficie: CantidadSchema.required(
    "errors.areaAcopioSolido.superficie.required",
  )
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "M2" } }),
  cercoPerimetral: yup
    .object()
    .required("errors.areaAcopioSolido.cercoPerimetral.required")
    .default(null),
  conCerramientoSuperior: yup
    .boolean()
    .required("errors.areaAcopioSolido.conCerramientoSuperior.required")
    .default(false),
});
